import ProductName from '@web/components/ProductName'
import ClosingCTA from '@web/sections/Products/ClosingCTA'
import FAQ from '@web/sections/Products/FAQ'
import Pricing from '@web/sections/Products/Pricing'
import ProductSummary from '@web/sections/Products/ProductSummary'
import ProofPoint from '@web/sections/Products/ProofPoint'
import RegulatoryDrivers from '@web/sections/Products/RegulatoryDrivers'
import SolutionsHeader from '@web/sections/Solutions/Header'
import TimeToValue from '@web/sections/Products/TimeToValue'
import ValueAdds from '@web/sections/Products/ValueAdds'
import { useEffect } from 'react'

const PAGE_TITLE =
  'Resilience Explorer® | Property · NPS-NH and LIM compliance for NZ councils · Urban Intelligence'
const PAGE_DESCRIPTION =
  'Resilience Explorer® | Property is the compliance engine for NZ councils. NPS-NH Property Risk Reports and regulation-compliant LIM Hazard Section Reports. Built for the 15 January 2026 NPS-NH commencement and the October 2025 LIM regulations. Live at Hamilton City Council.'

export function PropertyPage() {
  useEffect(() => {
    const previousTitle = document.title
    const meta = document.querySelector('meta[name="description"]')
    const previousDescription = meta?.getAttribute('content') ?? null

    document.title = PAGE_TITLE
    meta?.setAttribute('content', PAGE_DESCRIPTION)

    return () => {
      document.title = previousTitle
      if (previousDescription !== null) {
        meta?.setAttribute('content', previousDescription)
      }
    }
  }, [])

  return (
    <>
      <SolutionsHeader
        eyebrow="A module of Resilience Explorer®"
        logo={{ src: '/website/property_logo.svg', alt: 'Resilience Explorer® | Property' }}
        header={
          <>
            <ProductName /> enables you to issue compliant LIMs and defensible consent decisions on
            every property in minutes.
          </>
        }
        subheader="Built for NPS-NH and the new LIM regulations. So you can meet your hazard disclosure and decision-making requirements."
        ctaLabel="Book a 20-minute walkthrough"
        arcadeLink={{
          src: 'https://demo.arcade.software/O9roeYDHsNbyfanxrNDJ?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true',
          title: 'Resilience Explorer® | Property',
        }}
        descriptionLeft={
          <p>
            Councils are increasingly required to assess and communicate future natural hazard risk
            consistently across LIMs, consenting, and planning workflows. For many teams, this still
            relies on fragmented datasets, manual GIS analysis, and staff interpretation (NPS-NH, 15
            January 2026 | LIM, 17 October 2025).
          </p>
        }
        descriptionRight={
          <p>
            <ProductName /> brings hazard data, climate scenarios, risk classifications, mapping,
            and report generation into a single operational workflow, producing consistent,
            regulation-aligned outputs directly from council-approved datasets.
          </p>
        }
      />

      <TimeToValue />

      <ProofPoint />

      <RegulatoryDrivers />

      <ProductSummary />

      <ValueAdds />

      <Pricing />

      <FAQ />

      <ClosingCTA />
    </>
  )
}
